import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';

import { Account } from '../../models/account.model';
import { User } from '../../models/user.model';
import { StepState } from '../../models/step-state.model';
import { StepType } from '../../models/step-type.model';
import { AccountSecurityStepComponent } from '../account-security-step/account-security-step.component';
import { ImportantInformationStepComponent } from '../important-information-step/important-information-step.component';
import { YourProfileStepComponent } from '../your-profile-step/your-profile-step.component';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss']
})
export class StepperComponent implements OnInit, OnChanges {
  @ViewChild(ImportantInformationStepComponent, { static: false })
  private importantInformationStep: ImportantInformationStepComponent;

  @ViewChild(YourProfileStepComponent, { static: false })
  private yourProfileStep: YourProfileStepComponent;

  @ViewChild(AccountSecurityStepComponent, { static: false })
  private accountSecurityStep: AccountSecurityStepComponent;

  @Input() public stepNumber: number;
  @Input() public account: Account;
  @Input() public user: User;

  @Output() private stepChanged = new EventEmitter<string>();
  @Output() private stepModelChanged = new EventEmitter<StepState>();

  constructor(private changeDetector: ChangeDetectorRef) {}

  ngOnInit() {}

  public ngOnChanges(changes: SimpleChanges) {
    this.changeDetector.detectChanges();

    switch (this.stepNumber) {
      case StepType.ImportantInformation:
        this.stepChanged.emit(this.importantInformationStep.titleKeyName);
        break;
      case StepType.YourProfile:
        this.stepChanged.emit(this.yourProfileStep.titleKeyName);
        break;
      case StepType.AccountSecurity:
        this.stepChanged.emit(this.accountSecurityStep.titleKeyName);
        break;
    }
  }

  public IsActiveStep(stepType: string): boolean {
    return StepType[stepType] === this.stepNumber;
  }

  public onStepModelChanged(stepState: StepState): void {
    this.stepModelChanged.emit(stepState);
  }
}
